export default "__VITE_ASSET__BYHTMFbu__"